export default __webpack_public_path__ + "static/media/Interest-Active.9a507ecd.png";